module.exports = __webpack_public_path__ + "40725ee9b822ec6f5ff60aff376ea674.svg";